<nav class="navbar navbar-expand-sm menu-bar justify-content-between">
  <ul class="navbar-nav">
    <li class="nav-item" *ngIf="role.dpa_button_createkm">
      <a class="nav-link action-menu" style="color: white !important;" (click)="newKB($event)">สร้าง Knowledge Base</a>
    </li>
  </ul>
  <form class="form-inline">
    <!-- <input class="form-control filter" type="search" placeholder="Search"> -->
  </form>
</nav>

<div class="card card-default mt-3">
  <div class="card-body p-0">
    <div class="row">
      <div class="col-3 criteria">
        <div class="row mt-3">
          <div class="col-4 text-right">
            <h5 class="text-white">ค้นหาตาม:</h5>
          </div>
          <div class="col-8">
            <select class="form-control" [(ngModel)]="searchType" (change)="filterByKeyword()">
              <option value="a">ทั้งหมด</option>
              <option value="k">keyword</option>
              <option value="c">เนื้อหา</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 input-group">
            <input type="search" class="form-control search-field" placeholder="Search" [(ngModel)]="keyword"
              (keyup.enter)="filterByKeyword()">
            <div class="input-group-append">
              <button class="btn btn-primary bg-cust-blue" (click)="filterByKeyword()">
                <span class="fa fa-search"></span>
              </button>
            </div>
          </div>
          <div class="col-12 text-center mt-3">
            <h5 class="text-white">ค้นหาตามหมวดหมู่</h5>
          </div>
          <div class="col-12">
            <div class="card card-primary ">
              <div class="card-header bg-cust-blue">
                <h5 class="card-title">หมวดหมู่</h5>
              </div>
              <div class="card-body">
                <ul class="pl-3" style="list-style-type:none;" *ngFor="let g of categoryList; let i = index">
                  <li class="mb-3" (click)="filterByGroup(g.dpa_kmcategoryid)">
                    {{(i+1).toString() + ". " + g.dpa_name}}
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-12 text-center">
            <h5 class="text-white">ค้นหาตามช่วงเวลา</h5>
          </div>
          <div class="col-12 text-center">
            <div id="date" class="mb-3 bg-white"></div>
          </div>
        </div>
      </div>
      <div class="col-9 pb-5">
        <div class="row mt-3" *ngFor="let kb of showingKBList">
          <div class="col-12">
            <div class="news-header" [innerHtml]="kb.dpa_name | highlightSearch: Search"></div>
          </div>
          <div class="col-12">
            <h5 class="news-date">{{ kb.modifiedon | thaidate:'short' }}</h5>
          </div>
          <div class="col-12" *ngIf="kb.dpa_attch != ''">
            <div class="card card-default">
              <div class="card-body km-content" [innerHTML]="kb.dpa_attch"></div>
            </div>
          </div>
          <div class="col-12">
            <div class="card card-default">
              <div class="card-body p-5 km-content" [innerHTML]="kb.dpa_content | highlightSearch: Search"></div>
            </div>
          </div>
          <div class="col-12 text-right">
            <!-- <h6>ผู้สร้าง : {{kb.dpa_createdbyname}}</h6> -->
          </div>
        </div>

      </div>
    </div>
  </div>

</div>


<!-- Modal SMS-->
<div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="createModalLabel"
  aria-hidden="true" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header text-white bg-cust-blue">
        <h5 class="modal-title" id="createModalLabel">สร้าง Knowledge Base</h5>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-4">
            <label class="required">Title/เรื่อง</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" [(ngModel)]="createTitle">
            <span class="text-danger" *ngIf="submittedKB && (createTitle == null || createTitle == '')">
              กรุณาระบุ Title/เรื่อง
            </span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-4">
            <label class="two-row-lbl">Knowledge Base Type/</label><br>
            <label class="two-row-lbl">ประเภท</label>
          </div>
          <div class="col-8">
            <select class="form-control" [(ngModel)]="createType">
              <option value="">เลือก</option>
              <option *ngFor="let g of categoryList; let i = index" [value]="g.dpa_kmcategoryid">
                {{g.dpa_name}}
              </option>
            </select>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-4">
            <label>Keyword/คำสืบค้น</label>
          </div>
          <div class="col-8">
            <input type="text" class="form-control" [(ngModel)]="createKeyword">
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label>Content/เนื้อหา</label>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <textarea class="form-control" rows="8" [(ngModel)]="createContent"></textarea>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12">
            <label>ไฟล์แนบ</label>
          </div>
        </div>

        <!-- Upload-->
        <div class="row centered-content" id="divUpload">
          <div class="col-12">
            <div class="upload-btn-wrapper" style="width: 100px; cursor: pointer !important;">
              <!-- <input type="text" id="txtFileName" class="form-control" placeholder="เลือกไฟล์..."> -->
              <button class="btn btn-default text-primary"><i class="fas
                          fa-plus"></i>
                &nbsp;Upload</button>
              <input type="file" id="fileAttach" [accept]="AcceptExtension" (change)="FileSelect($event.target.files)"
                style="cursor: pointer !important;" />
            </div>
            <!-- <button class="btn btn-default" (click)="UploadFile()"><i class="fas
                          fa-upload"></i>
                      &nbsp;Upload</button> -->
          </div>
        </div>

        <div class="row centered-content">
          <div class="col-md-12">
            <table id="TableDocs" style="width: 100%;" class="table
                          table-bordered table-hover table-responsive-sm result-table
                          display nowrap">
              <thead class="sr-only">
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-12 table-responsive">
            <table id="TableDocs" style="width: 100%;" class="table
                  table-bordered table-hover table-responsive-sm result-table
                  display nowrap">
            </table>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-12 text-center">
            <button type="button" class="btn btn-info mr-2" (click)="createKB()">สร้าง</button>
            <button type="button" class="btn btn-info ml-2" data-dismiss="modal">ปิด</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/knowledge-base/knowledge-base.component.html